var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
        content: _vm.tooltip,
        placement: 'bottom',
    }),expression:"{\n        content: tooltip,\n        placement: 'bottom',\n    }"}],staticClass:"v-button-settings",class:{ 'v-button-settings--active': _vm.active }},[_vm._t("default",function(){return [_c('SettingsSVG')]}),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.count),expression:"count"}],staticClass:"v-button-settings__counter"},[_vm._v(" "+_vm._s(_vm.count)+" ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }